import type { SpecialKey } from '@nsb/core';

/**
 * Whether the choice stays open: never past the list emptying, so when an undo or a draft loaded again brings one back
 * to add, the choice waits closed for its button instead of opening by itself.
 */
export const stillChoosing = (choosing: boolean, addable: readonly SpecialKey[]) => choosing && addable.length > 0;
